<template>
  <div class="d-flex">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-icon color="primary">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item :disabled="!$auth.policies['update-attendance']">
          <v-list-item-title style="cursor: pointer" @click="editDialog = !editDialog">Sửa điểm danh</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item>
          <v-list-item-title style="cursor: pointer" @click="detailDialog = !detailDialog">
            Xem chi tiết
          </v-list-item-title>
        </v-list-item> -->
      </v-list>
    </v-menu>

    <EditAttendanceDialog
      :selectedAttendance="selectedAttendance"
      :checkinObject="checkinObject"
      :state="editDialog"
      @attendanceUpdated="$emit('attendanceUpdated')"
    />
    <!-- <AttendanceDetailDialog :student="student" :state="detailDialog" /> -->
  </div>
</template>

<script>
import EditAttendanceDialog from './EditAttendanceDialog.vue'
// import AttendanceDetailDialog from '@/modules/attendance/AttendanceDetailDialog.vue'

export default {
  props: {
    selectedAttendance: Object,
    checkinObject: {
      type: Object,
      default: null
    }
  },
  components: {
    EditAttendanceDialog
    // AttendanceDetailDialog
  },

  data() {
    return {
      // detailDialog: false,
      editDialog: false
    }
  }
}
</script>
